// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrdersUsingOptions from './ordersUsingOptions';
import React from 'react';

function OrdersUsingOptionsPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-using-options-page">
            <OrdersUsingOptions />
        </AuthenticatedPage>
    );

}
OrdersUsingOptionsPage.displayNAme = 'OrdersUsingOptionsPage';

export default OrdersUsingOptionsPage;
